// extracted by mini-css-extract-plugin
export default {"infoSection":"styles_infoSection__wr6vD","title":"styles_title__EJndG"};